import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { QualificationsModalComponent } from '../employe-access/qualifications-modal/qualifications-modal.component';
import { ModErrorComponent } from '../modals/mod-error/mod-error.component';
import { SelfVerificationService } from '../service/self-verification.service';


@Component({
  selector: 'app-external-verification-list',
  templateUrl: './external-verification-list.component.html',
  styleUrls: ['./external-verification-list.component.css']
})
export class ExternalVerificationListComponent implements OnInit {

  accesses : any[];
  person:any;
  email:any;
  rut:any;
  accessDetail:any[];
  typePeopleContractor:boolean;
  emailRut: any;
  title = 'RUT'
  displayQualification = false;
  constructor(private dataApi: SelfVerificationService,
              private _snackBar: MatSnackBar,
              public dialog: MatDialog,
              private spinner: NgxSpinnerService,
              private route: ActivatedRoute,) { 
                
                 this.route.snapshot.paramMap.get('email');
                 this.email = this.route.snapshot.paramMap.get('email').split('-*')[0];
                 this.rut = this.route.snapshot.paramMap.get('email').split('-*')[1];
                 this.title = this.route.snapshot.paramMap.get('email').split('-*')[2];
                 this.emailRut = this.email + '-*' + this.rut + '-*' + this.title;
                 
              }

  ngOnInit() {
    //aqui abrir spinner
      this.searchPerson(this.email, this.rut);
    

  }

  searchPerson(email, rut){ 
    this.spinner.show("loading"); 
      this.dataApi.getSearchExternalMailRut(email, rut).subscribe(
        (data: any)=>{
          if(data==null || data==undefined || data.length==0){
            this.person= [];
          }else{
            this.person=  data[0];
            if(this.person.employeeType == "Employee")
                this.typePeopleContractor = false;
            else 
                this.typePeopleContractor = true;
            this.getAuthorisedAccessesSelfCheck(this.person.mdmid)
          }
          this.spinner.hide("loading");
        },
        (err: any)=>{
         
          this.person= null;
          this.spinner.hide("loading");
        }
      );

    }
  
  getAuthorisedAccessesSelfCheck(mdmid)
  {
    this.spinner.show("loadingSecond"); 
    this.dataApi.getAuthorisedAccessesSelfCheck(mdmid).subscribe(
      (data: any)=>{
        if(data==null || data==undefined || data.length==0){
          this.accesses= [];
          this.spinner.hide("loadingSecond")
        }else{
          this.accesses=data.myAccesses;
          // this.accessDetail=data.myAccesses.accessDetail
          this.spinner.hide("loadingSecond")
        }this.spinner.hide("loadingSecond");
        //hide spinner
      },
      (err: any)=>{
        this.accesses=[];
        this.spinner.hide("loadingSecond");
      }
    );
    
  }
  seeQualifications(qualifications) {
    this.dialog.open(QualificationsModalComponent, { panelClass: 'myapp-no-padding-dialog', data: qualifications });
  }



}
